import { CURRENT_EVENT_SLUG } from "./event";

export type GooseGamePointsIconShape = "gem" | "luma";

interface GooseGamePointsConfig {
  name: string;
  iconShape: GooseGamePointsIconShape;
}

const DEFAULT_POINTS_CONFIG: GooseGamePointsConfig = {
  name: "Gems",
  iconShape: "gem",
};

const POINTS_CONFIG_BY_EVENT: Partial<Record<string, GooseGamePointsConfig>> = {
  hackthenorth2026: {
    name: "Luma",
    iconShape: "luma",
  },
};

const currentPointsConfig =
  POINTS_CONFIG_BY_EVENT[CURRENT_EVENT_SLUG] ?? DEFAULT_POINTS_CONFIG;

export const GOOSE_GAME_POINTS_NAME = currentPointsConfig.name;
export const GOOSE_GAME_POINTS_ICON_SHAPE = currentPointsConfig.iconShape;
